import Immutable from 'immutable';
import reducerCreator from '../../tools/reducer-creator';
import * as types from '../../actions/vacancies/types';

const initialState = Immutable.fromJS({
  applicationFlowType: null,
  applicationId: null,
  isLoading: false,
  errors: null,
  status: null
});

export default reducerCreator(initialState, {
  [types.VACANCY_SET_PUBLIC_APPLICATION_LOADING]: (state, { isLoading }) =>
    state.set('isLoading', isLoading),

  [types.VACANCY_SET_PUBLIC_APPLICATION]: (state, { applicationId, applicationFlowType }) => 
    state
      .set('applicationId', applicationId)
      .set('applicationFlowType', applicationFlowType),

  [types.VACANCY_SET_PUBLIC_APPLICATION_ERRORS]: (state, { errors }) =>
    state.set('errors', Immutable.fromJS(errors)),
  
  [types.VACANCY_SET_PUBLIC_APPLICATION_STATUS]: (state, { status }) =>
    state.set('status', status),

  [types.VACANCY_RESET_PUBLIC_APPLICATION]: () =>
    initialState
});


// WEBPACK FOOTER //
// ./src/reducers/school/school-public-vacancy-application.js